const { toString } = require('@/functions/transform');

class Template {
    constructor() {
        this.name = '';
        this.printDriverRef = '';
        this.content = '';
    }

    getHydrationMap() {
        return {
            name: toString,
            printDriverRef: toString,
            content: toString,
        };
    }
}

module.exports = Template;
